import React, { useEffect, useRef } from 'react'
import { useTitle, useRequest } from 'ahooks'
import Delete from './Delete'
import SystemMaintenance from './SystemMaintenance'
import { getHtmlInfo } from '@/api'
import { queryUrl } from '@/utils'

interface IHTMLInfo {
  id: number
}

interface IHTMLContent {
  id: number
  content: string
  title: string
}

interface IDefaultMarketingProps {
  id: number
}

const CUSTOM_MARKETING_PAGE_ID = 130
const customPageRenderers: Record<number, React.ComponentType> = {
  [CUSTOM_MARKETING_PAGE_ID]: SystemMaintenance,
}

const DefaultMarketing = ({ id }: IDefaultMarketingProps) => {
  const { data, error, loading } = useRequest(() => getHtmlInfo<IHTMLInfo, IHTMLContent>({ id }))
  const richRef = useRef<HTMLElement | null>(null)
  const content = data?.content
  const title = data?.title || ''
  useTitle(title)

  useEffect(() => {
    const richElement = richRef.current
    const clickImage = (event: Event) => {
      const element = event.target as HTMLElement
      const href = element.getAttribute('data-href')

      if (href) {
        window.location.href = href
      }
    }

    richElement?.addEventListener('click', clickImage)
    return () => richElement?.removeEventListener('click', clickImage)
  }, [])

  return (!error && content) || loading ? (
    <div
      className={'p-4'}
      ref={(ref) => (richRef.current = ref)}
      dangerouslySetInnerHTML={{ __html: content || '' }}
    ></div>
  ) : (
    <Delete />
  )
}

const Marketing = () => {
  const { id } = queryUrl()
  const pageId = Number(id)
  const CustomPage = customPageRenderers[pageId]

  if (CustomPage) {
    return <CustomPage />
  }

  return <DefaultMarketing id={pageId} />
}

export default Marketing
